import "./toolbar.scss";

import { isNil } from "lodash";
import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import { withContainerContext } from "../container/ContainerContext";

const ToolbarView = props => {
  let style = {};
  if (!isNil(props.paddingLeft)) {
    style.paddingLeft = `${props.paddingLeft}px`;
  }
  if (!isNil(props.paddingRight)) {
    style.paddingRight = `${props.paddingRight}px`;
  }
  if (!isNil(props.fontSize)) {
    style.fontSize = `${props.fontSize}px`;
  }
  return (
    <div
      id={props.domId}
      style={style}
      className={`toolbar ${props.className ? props.className : ""} ${props.isEditMode ? "editMode" : ""}`}
    >
      {props.children}
    </div>
  );
};

ToolbarView.propTypes = {
  className: PropTypes.string,
  domId: PropTypes.string,
  children: PropTypeShapes.elementOrArray,
  isEditMode: PropTypes.bool,
  fontSize: PropTypes.number,

  // From withContainerContext
  paddingLeft: PropTypes.number,
  paddingRight: PropTypes.number
};

export default withContainerContext(ToolbarView);
